/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetPlatformMCPOnboardingSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type GetPlatformMCPOnboardingRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type GetPlatformMCPOnboardingSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetPlatformMCPOnboardingSecurity$outboundSchema: z.ZodMiniType<
  GetPlatformMCPOnboardingSecurity$Outbound,
  GetPlatformMCPOnboardingSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getPlatformMCPOnboardingSecurityToJSON(
  getPlatformMCPOnboardingSecurity: GetPlatformMCPOnboardingSecurity,
): string {
  return JSON.stringify(
    GetPlatformMCPOnboardingSecurity$outboundSchema.parse(
      getPlatformMCPOnboardingSecurity,
    ),
  );
}

/** @internal */
export type GetPlatformMCPOnboardingRequest$Outbound = {
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const GetPlatformMCPOnboardingRequest$outboundSchema: z.ZodMiniType<
  GetPlatformMCPOnboardingRequest$Outbound,
  GetPlatformMCPOnboardingRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function getPlatformMCPOnboardingRequestToJSON(
  getPlatformMCPOnboardingRequest: GetPlatformMCPOnboardingRequest,
): string {
  return JSON.stringify(
    GetPlatformMCPOnboardingRequest$outboundSchema.parse(
      getPlatformMCPOnboardingRequest,
    ),
  );
}
